import React from "react"
import { Fade } from "@material-ui/core"

interface ToolTipPopUpProps {
    show: boolean
    message: JSX.Element
    position: {
        top: number
        left: number
    }
}

const ToolTipPopUp: React.FC<ToolTipPopUpProps> = ({ show, message, position }) => {
    if (!show) return null

    return(
        <Fade in={true}>
            <div data-testid="popUpMessage" style={getPopUpStyles(position)}>
                <div style={getBeakStyles()}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="8" height="16" viewBox="0 0 8 16" fill="none">
                        <path fillRule="evenodd" clipRule="evenodd" d="M8 16L0 8L8 0L8 16Z" fill="#007DB8"/>
                    </svg>
                </div>
                {message}
            </div>
        </Fade>
    )
}

export default ToolTipPopUp



// Helpers

function getBeakStyles(): React.CSSProperties {
    return {
        position: "absolute",
        left: -8,
        top: 16
    }
}

function getPopUpStyles(position: { top: number; left: number }): React.CSSProperties {
    return {
        position: "fixed",
        top: position.top,
        left: position.left,
        pointerEvents: "none",
        maxWidth: 300,

        display: "inline-flex",
        padding: "16px",
        flexDirection: "column" as "column",
        alignItems: "flex-start",
        gap: "8px",
        borderRadius: "8px",
        backgroundColor: "#007DB8",

        color: "#FFF",
        fontFamily: "Roboto",
        fontSize: "14px",
        fontStyle: "normal",
        fontWeight: "400",
        lineHeight: "20px"
    }
}